import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from './Utils';

class VirtualAgent extends Component {
  constructor() {
    super();
    this.state = {
      dataStartedProcessing: false,
      showLoader: false,
      data: [],
      editedName: "",
      editedDescription: "",
      editedDheeProjectId: "",
      editedRuntimeUrl: "",
      editedInstanceId: "",
      disabled: false,
      editedId: "-1",
      pageNum: null,
      paginationValue: 10,
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      searchTerm: "",
      noMatchingData: false,
      isLoading: true,
      tableReady: false,

    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }
  componentDidMount() {
    var thisController = this;
    const savedPage = localStorage.getItem("lastAiAgentActivePage");
    if (savedPage !== null) {
      thisController.restoredPage = parseInt(savedPage);
      localStorage.removeItem("lastAiAgentActivePage");
    } else {
      thisController.restoredPage = 1;
    }


    thisController.fetchVirtualAgentDetails();

    if (thisController.props.location.state != undefined) {
      thisController.setState({ pageNum: thisController.props.location.state.pageNum });
    }

  }
  addNewVirtualAgentRow = () => {
    var thisController = this;
    thisController.state.paginationValue = thisController.state.paginationValue + 5;
    if (thisController.state.pageNum != 0) {
      thisController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      id: '',
      name: '',
      description: '',
      dheeProjectId: '',
      runtimeUrl: '',
      instanceId: ''
    });
    this.setState({
      data: this.state.data,
      noMatchingData: false,
      disabled: true,
    })
  }

  makeCelledit(row, e) {
    this.markAsBeingEdited(row.id);
    this.state.editedName = row.name;
    this.state.editedDescription = row.description;
    this.state.editedDheeProjectId = row.dheeProjectId;
    this.state.editedRuntimeUrl = row.runtimeUrl;
    this.state.editedInstanceId = row.instanceId;
    this.setState(this.state);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  fetchVirtualAgentDetails = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/load-agents",
      method: 'GET',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var messages = res.result;
          thisController.state.disabled = false;
          thisController.state.noMatchingData = false;
          thisController.state.isLoading = false;
          thisController.state.showLoader = true;
          thisController.state.data = messages;
          thisController.data = messages;
          thisController.state.pageNum = thisController.restoredPage || 1;
          thisController.state.tableReady = true;
          thisController.setState(thisController.state);
        } else {
          // thisController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      }
    });
  }

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no virtual agent present. </p>
    </div>
  );
  saveVirtualAgentDetails(row, e) {
    var thisController = this;
    var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

    row.name = document.getElementById("name" + row.id).innerText.trim();
    row.description = document.getElementById("description" + row.id).innerText.trim();
    row.dheeProjectId = document.getElementById("dheeProjectId" + row.id).innerText.trim();
    row.runtimeUrl = document.getElementById("runtimeUrl" + row.id).innerText.trim();
    row.instanceId = document.getElementById("instanceId" + row.id).innerText.trim();


    var agentName = row.name;
    var projectId = row.dheeProjectId;
    var runtimeUrl = row.runtimeUrl;
    var instanceId = row.instanceId;
    if (agentName == "" || projectId == "" || runtimeUrl == "" || instanceId == "") {
      thisController.notifyMsgFieldEmpty();
    }
    else if (!namePattern.test(agentName)) {
      thisController.notifyImproperName();
    }

    else {
      thisController.state.editedId = "-1";
      thisController.state.dataStartedProcessing = true;
      thisController.setState(thisController.state);
      var saveData = {
        name: row.name,
        description: row.description,
        dheeProjectId: row.dheeProjectId,
        runtimeUrl: row.runtimeUrl,
        instanceId: row.instanceId
      }

      var timer = setInterval(function () {
        clearTimeout(timer);

        $.ajax({
          url: "/my-jeeva-api/add-virtual-agent",
          method: 'POST',
          headers: {
            'Authorization': "Bearer " + localStorage.getItem("access_token"),
            'Content-Type': "application/json",

          },
          data: JSON.stringify(saveData),
          success: function (res) {
            if (res.success === true) {
              thisController.state.dataStartedProcessing = false;
              thisController.notifyVirtualAgentAdded();
              thisController.fetchVirtualAgentDetails();
              thisController.setState({ disabled: false, dataStartedProcessing: false });
            } else {
              thisController.notifyFailedResponse(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "";
            }
          }
        })

      }, 2000);
    }
  }

  updateVirtualAgentDetails(row, e) {
    row.name = document.getElementById("name" + row.id).innerText.trim();
    row.description = document.getElementById("description" + row.id).innerText.trim();
    row.dheeProjectId = document.getElementById("dheeProjectId" + row.id).innerText.trim();
    row.runtimeUrl = document.getElementById("runtimeUrl" + row.id).innerText.trim();
    row.instanceId = document.getElementById("instanceId" + row.id).innerText.trim();
    var thisController = this;

    var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);


    var agentName = thisController.state.editedName;
    var agentDesc = thisController.state.editedDescription;
    var projectId = thisController.state.editedDheeProjectId;
    var agentRuntimeUrl = thisController.state.editedRuntimeUrl;
    var agentInstanceId = thisController.state.editedInstanceId;

    if (agentName == "" || projectId == "" || agentRuntimeUrl == "" || agentInstanceId == "") {
      thisController.notifyMsgFieldEmpty();
    }
    else if (!namePattern.test(agentName)) {
      thisController.notifyImproperName();
    }

    else {
      var updatedData = {
        id: row.id,
        name: agentName,
        description: agentDesc,
        dheeProjectId: projectId,
        runtimeUrl: agentRuntimeUrl,
        instanceId: agentInstanceId
      };
      $.ajax({
        url: "/my-jeeva-api/update-virtual-agent",
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            thisController.state.editedId = "-1";
            thisController.notifyVirtualAgentUpdate();
            thisController.fetchVirtualAgentDetails();
          } else {
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        }


      })
    }

  }
  openDeletePopUp = (row) => {

    confirmAlert({
      title: 'Confirm to Delete',
      message: `Are you sure you want to delete ${row.name} ?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.callDeleteVirtualAgentApi(row.id)
        },
        {
          label: 'No',
        }
      ]
    });
  }

  callDeleteVirtualAgentApi = (id) => {
    let virtualAgentData = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      virtualAgentData.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-virtual-agent/" + id,

        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {

          if (res.success === true) {

            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            virtualAgentData.splice(id, 1);
            deleteApiViewController.refreshData();
          } else {
            // virtualAgentData.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        }
      });
    }

    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchVirtualAgentDetails();


  }
  notifyError() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"

    });
  }

  notifyDataProcessing() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Hold on.Your data is saving...
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyVirtualAgentAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Virtual Agent Details added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyVirtualAgentUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Virtual Agent Details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperName() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please provide a valid name</b>, {
      position: "top-center"
    });
  }

  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Virtual Agent Detail deleted successfully</b>, {
      position: "top-center",
    });
  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all the fields</b>, {
      position: "top-center"
    });

  }
  refreshData = (id) => {
    console.log("Resetting the data");
    this.state.data = [];
    this.state.editedId = "-1";
    this.state.disabled = false;
    this.state.isLoading = true;
    this.state.noMatchingData = false;
    this.state.searchTerm = "";
    this.setState(this.state);
    this.fetchVirtualAgentDetails();
  }

  handleNameChange = (e) => {
    this.state.editedName = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleDescriptionChange = (e) => {
    this.state.editedDescription = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleDheeProjectIdChange = (e) => {
    this.state.editedDheeProjectId = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleRuntimeUrlChange = (e) => {
    this.state.editedRuntimeUrl = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  handleInstanceIdChange = (e) => {
    this.state.editedInstanceId = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  addVirtualAgentSkills = (row, e) => {
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastAiAgentActivePage", pageToSave);

    this.props.history.push({
      pathname: '/projectmgmt/virtual-agent-skills',
      state: {
        virtualAgentId: row.id,
        VirtualAgentName: row.name,
        pageNum: this.state.pageNum
      }
    });
    this.setState(this.setState)
  }

  onPageChange = (e) => {
    this.restoredPage = e;
    this.setState({ pageNum: e });
    localStorage.setItem("lastAiAgentActivePage", e);
  };

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field] ? rowA[field].toLowerCase() : '';
    const b = rowB[field] ? rowB[field].toLowerCase() : '';

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.data = [];
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/search-agents-data",
      method: "GET",
      data: {
        searchTerm: thisController.state.searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.data = [];
            thisController.state.noMatchingData = false;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
            thisController.state.data = res.result;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });
  };

  clearSearchData = () => {
    var thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      thisController.fetchVirtualAgentDetails();
    });
  }

  render() {
    const { data } = this.state;
    var agentController = this;

    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}> Name</b>,
        // width: "19vw",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('name'),
        selector: (row) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                fontSize: "15px",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => {
                this.handleNameChange(e, row);
              }}
              id={"name" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.name}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Description</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('description'),
        // width: "45vw",
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
                overflowY: "scroll"
              }}
              onInput={(e) => {
                this.handleDescriptionChange(e, row);
              }}
              id={"description" + row.id}
              name={"description" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.description}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Project ID</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('dheeProjectId'),
        // width: "45vw",
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => {
                this.handleDheeProjectIdChange(e, row);
              }}
              id={"dheeProjectId" + row.id}
              name={"dheeProjectId" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.dheeProjectId}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Runtime URL</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('runtimeUrl'),
        // width: "45vw",
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => {
                this.handleRuntimeUrlChange(e, row);
              }}
              id={"runtimeUrl" + row.id}
              name={"runtimeUrl" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.runtimeUrl}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Instance ID</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('instanceId'),
        // width: "45vw",
        selector: (row) => (
          <div>
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => {
                this.handleInstanceIdChange(e, row);
              }}
              id={"instanceId" + row.id}
              name={"instanceId" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.instanceId}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Actions</b>,
        width: 100,
        selector: (row) => (
          <div id="action">
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: '-6px'
              }} >
              <img className="img-responsive"
                title={row.id == "" || (row.id == this.state.editedId) ? 'Save' : 'Edit'}
                style={{
                  marginTop: '6px',
                  backgroundColor: '#282a65',
                  borderRadius: '5px',
                  padding: '1px',
                  width: '100%',
                  fontSize: '15px'
                }}
                src={row.id == "" ? this.saveImageSrc : ((row.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                onClick={(e) => {
                  this.state.dataStartedProcessing
                    ? this.notifyDataProcessing() :
                    row.id == "" ? this.saveVirtualAgentDetails(row, e) : (row.id == this.state.editedId) ?
                      this.updateVirtualAgentDetails(row, e) : this.makeCelledit(row, e);
                }} />
            </button>
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: '-9px',
                marginLeft: '-6px'
              }}
              title="Delete">
              <img className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                title="Delete"
                style={{
                  marginTop: '6px',
                  backgroundColor: '#282a65',
                  borderRadius: '5px',
                  padding: '1px'
                }}
                onClick={() => (row.id) === '' ?
                  this.fetchVirtualAgentDetails() :
                  this.openDeletePopUp(row)} />
            </button >
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
              }}
              title="Skills"
              onClick={(e) => {
                this.addVirtualAgentSkills(row, e);
              }}
            >
              <img
                className="img-responsive"
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px"
                }}
                src="./assets/images/skills.png"
              />
            </button>
          </div>
        ),
      },
    ];
    return (
      <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        {/* for reactTable */}
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        {/* Font Awesome Icons */}
        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
        {/* IonIcons */}
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />
        <link rel="stylesheet" href="./assets/css/styles.css" />
        <div className="row" style={{ marginLeft: "15px" }}>
          <div className="col-sm-4" style={{ marginTop: '2px' }} >

          </div>
        </div>

        <div className="row" style={{ marginLeft: '14px' }}>
          <div className="col-sm-5">
            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '15px' }}>
              Virtual Agent</h6>
          </div>
          <div className="col-sm-5" Align="right">
            <input
              type="text"
              style={{
                width: "10vw",
                border: "1px solid #777676",
                borderRadius: "3px",
                padding: "10px",
                height: "0.6vw",
                paddingRight: "2rem",
              }}
              value={this.state.searchTerm}
              onChange={this.handleSearch}
              placeholder="Search ..."
            />
            {this.state.searchTerm && (
              <span
                onClick={() => this.clearSearchData()}
                style={{
                  // position: "absolute",
                  right: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#777676",
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  lineHeight: 1,
                  userSelect: "none",
                  marginLeft: "-1vw"
                }}
              >
                ×
              </span>
            )}
          </div>
          <div 
          // className="col-sm-2 " 
          id='addrefresh-btn' style={{ marginTop: '-18px', marginLeft: "4vw" }}>
            <div className="d-flex flex-row-reverse pt-2" style={{ marginTop: '-1vh' }}>

              <div className="p-2" style={{ marginBottom: '10px' }}>

                <button className="btn action-button"
                  id="addMsg" title=" Add "
                  onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewVirtualAgentRow}>
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: '15px', marginTop: '-15px' }}>
          <div className="col-lg-12 ">
            {!this.state.noMatchingData &&
              <div className="card">
                {this.state.isLoading && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading ...</p>
                  </div>
                )}
                {!this.state.isLoading && this.state.data.length === 0 && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>There are no virtual agent present.</p>
                  </div>
                )}
                {(!this.state.isLoading && this.state.data.length > 0) && (

                  <DataTable
                    data={this.state.data}
                    key={"table-" + this.state.pageNum}
                    onChangePage={this.onPageChange}
                    paginationDefaultPage={this.state.pageNum || 1}
                    columns={columns}
                    defaultPageSize={10}
                    pageSizeOptions={[5, 10, 15]}
                    pagination={this.state.paginationValue}
                    noDataComponent={<this.CustomNoDataComponent />}
                  />
                )}
              </div>
            }
            <ToastContainer className="Toast-at-center" />
          </div>
        </div>
        <div className='card'>
          {this.state.noMatchingData &&
            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
              <p>No matching options found ...</p>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default VirtualAgent;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/VirtualAgent.js